exports = module.exports = require("../../../../../../../node_modules/@zxcabs/rtl-css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dash-text-placeholder{font-size:17px;line-height:15px;font-weight:800;color:#979797;filter:blur(2px);white-space:nowrap}", ""]);

// exports
